import type { EventSchema, User_BucketAdded } from 'cpool-events';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    bucket: EventSchema<User_BucketAdded>['type'];
};

export const schemaUserResolver_GetAdvisersByBucket = z.array(
    UsersTableDefinitionZod.pick({
        assignable: true,
        buckets: true,
        firstName: true,
        id: true,
        lastName: true,
        role: true,
        state: true,
    }),
);

export type SchemaUserResolver_GetAdvisersByBucket = z.infer<typeof schemaUserResolver_GetAdvisersByBucket>;

export type UserResolver_GetAdvisersByBucket = Resolver<Arguments, SchemaUserResolver_GetAdvisersByBucket>;
